/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbRespCollectionsLayout_viewer$ref = any;
type detectPageExistsAndRedirect_viewer$ref = any;
type getDomainLinksSb_viewer$ref = any;
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespCollectionsRootQueryVariables = {
    readonly userId?: string | null;
    readonly fetchUser: boolean;
    readonly uriRef?: string | null;
    readonly first: number;
    readonly page: number;
    readonly localeOrigin?: string | null;
    readonly isTrade: boolean;
    readonly showSeller: boolean;
    readonly followSearchPages?: ReadonlyArray<string | null> | null;
    readonly followSearchTypes?: ReadonlyArray<types | null> | null;
    readonly contentModuleId?: string | null;
    readonly eligibleAbTest?: string | null;
    readonly userZipCode?: string | null;
    readonly fetchSb: boolean;
    readonly disableForceFacet?: boolean | null;
};
export type sbRespCollectionsRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": getDomainLinksSb_viewer$ref & SbRespCollectionsLayout_viewer$ref & detectPageExistsAndRedirect_viewer$ref;
    } | null;
};
export type sbRespCollectionsRootQuery = {
    readonly response: sbRespCollectionsRootQueryResponse;
    readonly variables: sbRespCollectionsRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "uriRef",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localeOrigin",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "showSeller",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchPages",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "followSearchTypes",
    "type": "[types]",
    "defaultValue": [
      "SEARCH"
    ]
  },
  {
    "kind": "LocalArgument",
    "name": "contentModuleId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "eligibleAbTest",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": "0"
  },
  {
    "kind": "LocalArgument",
    "name": "fetchSb",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "disableForceFacet",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v2 = [
  {
    "kind": "Variable",
    "name": "disableForceFacet",
    "variableName": "disableForceFacet"
  },
  {
    "kind": "Variable",
    "name": "eligibleAbTest",
    "variableName": "eligibleAbTest"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "localeOrigin",
    "variableName": "localeOrigin"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE"
  }
],
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkReference",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "iconUri",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hexCode",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkable",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedFilterName",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "moduleType",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "photo",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subtitle",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkText",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "contemporaryTrackingString",
  "args": null,
  "storageKey": null
},
v31 = [
  (v26/*: any*/),
  (v9/*: any*/)
],
v32 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "seller",
  "storageKey": null,
  "args": null,
  "concreteType": "Seller",
  "plural": false,
  "selections": (v31/*: any*/)
},
v33 = [
  {
    "kind": "Variable",
    "name": "isTrade",
    "variableName": "isTrade"
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": "searchAndBrowse"
  }
],
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "convertedAmountList",
  "storageKey": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "plural": true,
  "selections": [
    (v34/*: any*/),
    (v18/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v37 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v38 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "paragraphs",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewParagraph",
  "plural": true,
  "selections": [
    (v19/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "text",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "mobileText",
      "name": "text",
      "args": (v37/*: any*/),
      "storageKey": "text(formatType:\"MOBILE\")"
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "alias": "mobileTitle",
  "name": "title",
  "args": (v37/*: any*/),
  "storageKey": "title(formatType:\"MOBILE\")"
},
v40 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isCustomizable",
  "args": null,
  "storageKey": null
},
v41 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v42 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v43 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": (v33/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantityDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    (v36/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "lowestShipmentQuote",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "complimentaryShipping",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedAmountList",
          "storageKey": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "plural": true,
          "selections": [
            (v18/*: any*/),
            (v34/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isWhiteGlove",
          "args": null,
          "storageKey": null
        },
        (v9/*: any*/)
      ]
    },
    (v9/*: any*/)
  ]
},
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v9/*: any*/)
      ]
    },
    (v9/*: any*/)
  ]
},
v48 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v49 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "placeholder",
  "args": null,
  "storageKey": null
},
v50 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "masterOrZoomPath",
  "args": null,
  "storageKey": null
},
v51 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "versions",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "webPath",
      "args": null,
      "storageKey": null
    }
  ]
},
v52 = {
  "kind": "LinkedField",
  "alias": "productPhotos",
  "name": "photos",
  "storageKey": "photos(limit:1)",
  "args": (v48/*: any*/),
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    (v49/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    (v50/*: any*/),
    (v51/*: any*/),
    (v9/*: any*/)
  ]
},
v53 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v54 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "measurement",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "dimensions",
      "name": "display",
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unit",
          "args": null,
          "storageKey": null
        },
        (v53/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "size",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSize",
      "plural": false,
      "selections": [
        (v53/*: any*/)
      ]
    }
  ]
},
v55 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "sellerProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "SellerProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "company",
      "args": null,
      "storageKey": null
    }
  ]
},
v56 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "photos",
  "storageKey": "photos(limit:1)",
  "args": (v48/*: any*/),
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    (v49/*: any*/),
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "largePath",
      "args": null,
      "storageKey": null
    },
    (v50/*: any*/)
  ]
},
v57 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "daysRelativeToExpiration",
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v59 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "benefit",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sbRespCollectionsRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "getDomainLinksSb_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "SbRespCollectionsLayout_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "detectPageExistsAndRedirect_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "sbRespCollectionsRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "itemSearch",
            "storageKey": null,
            "args": (v2/*: any*/),
            "concreteType": "ItemSearchQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "languageAnnotations",
                "storageKey": null,
                "args": null,
                "concreteType": "LanguageAnnotations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "available",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "href",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hrefLang",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "pageExists",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayUriRef",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "redirect",
                "storageKey": null,
                "args": null,
                "concreteType": "redirectType",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "location",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isCollectionsModuleEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "BROWSE_COLLECTIONS_MODULES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_COLLECTIONS_MODULES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isBillboardAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isThinPageEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isShopByRoomEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SHOP_BY_ROOM"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbRespFollowSearchEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "disableFollowSearchStickyBanner",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "disableFollowSearchStickyBanner"
              }
            ],
            "storageKey": "isEnabled(key:\"disableFollowSearchStickyBanner\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isContentModuleEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "BROWSE_CONTENT_MODULES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSkyscraperAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuSearchWithinEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isMatchedSetsEnabled",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enableMatchedSetsFacet"
              }
            ],
            "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSearchWithinFilterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "REFINE_MENU_SEARCH"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isDeliveryOptionsDisabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
          },
          {
            "kind": "LinkedField",
            "alias": "locations",
            "name": "itemFacetSearch",
            "storageKey": null,
            "args": [
              {
                "kind": "Literal",
                "name": "facetName",
                "value": "location"
              },
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "getExactMatches",
                "value": false
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1
              },
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "zipCode",
                "variableName": "userZipCode"
              }
            ],
            "concreteType": "ItemFacetsQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemFacetsQueryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FilterValueType",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isTileAdEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": (v3/*: any*/),
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isVisuallySimilarEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "VISUALLY_SIMILAR"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
          },
          {
            "kind": "ScalarField",
            "alias": "enableSearchLandingPage",
            "name": "isEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "enableSearchLandingPage"
              }
            ],
            "storageKey": "isEnabled(key:\"enableSearchLandingPage\")"
          },
          (v9/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeProgramsQuery",
                "storageKey": "tradeProgramsQuery(programCodes:[\"BRONZE\"])",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "programCodes",
                    "value": [
                      "BRONZE"
                    ]
                  }
                ],
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": "isSbTradeFreeShippingTestDisabled",
                "name": "isEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableSbTradeFreeShippingTest"
                  }
                ],
                "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "parentPrograms",
                    "name": "tradeProgramsQuery",
                    "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "programCodes",
                        "value": [
                          "MEMBER",
                          "BRONZE",
                          "SILVER",
                          "GOLD",
                          "PLATINUM"
                        ]
                      }
                    ],
                    "concreteType": "LoyaltyProgram",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v6/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "maxPoints",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "minPoints",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchSb",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "itemSearch",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "ItemSearchQueryConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "vanityUriRef",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "searchCorrections",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "semanticSearchTerm",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "suggestions",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchCorrectionSuggestionsValues",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uri",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalResults",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canFollowSearch",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "meta",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "header",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canonical",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "prev",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "disableIndexing",
                        "args": null,
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "next",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "microdata",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "appliedFilters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v15/*: any*/),
                          (v5/*: any*/),
                          (v16/*: any*/),
                          (v11/*: any*/)
                        ]
                      },
                      (v17/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canBeDismissed",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "clearAllLinkReference",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "breadcrumbs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseBreadcrumbs",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "path",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "topCategoryL1",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayMaxNumberOfPages",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clearAppliedFiltersLinkReference",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "filters",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "stats",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "stats",
                            "plural": true,
                            "selections": [
                              (v19/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "values",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v11/*: any*/),
                          (v15/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalCount",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isAttributePage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "browseContentModule",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "contentModuleId",
                        "variableName": "contentModuleId"
                      }
                    ],
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleRegular",
                        "selections": [
                          (v14/*: any*/),
                          (v13/*: any*/),
                          (v22/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModuleBanner",
                        "selections": [
                          (v22/*: any*/),
                          (v13/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "ContentModulePromo",
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pillText",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "headline",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subtext",
                            "args": null,
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          (v25/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "sort",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SortType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "options",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortAvailableOptions",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currentOption",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "searchTerm",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v13/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v32/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": "displayPriceTracking",
                                "name": "displayPrice",
                                "storageKey": null,
                                "args": (v33/*: any*/),
                                "concreteType": "ItemDisplayPriceType",
                                "plural": true,
                                "selections": [
                                  (v35/*: any*/),
                                  (v36/*: any*/)
                                ]
                              },
                              (v9/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quickViewDisplay",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "QuickViewDisplayType",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v13/*: any*/),
                                  (v39/*: any*/)
                                ]
                              },
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v52/*: any*/),
                              (v54/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "displayInfo",
                                "storageKey": null,
                                "args": (v33/*: any*/),
                                "concreteType": "ItemDisplayInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ctas",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CTADisplay",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showMakeOffer",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "photos",
                                "storageKey": "photos(limit:1)",
                                "args": (v48/*: any*/),
                                "concreteType": "ItemPhoto",
                                "plural": true,
                                "selections": [
                                  (v51/*: any*/),
                                  (v9/*: any*/)
                                ]
                              },
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "showSeller",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": [
                                      (v55/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "isTrade",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "lowestShipmentQuote",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ShipmentQuote",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "isFreeToBuyer",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": "relatedItems",
                    "name": "thinBrowseRelatedItems",
                    "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 12
                      },
                      {
                        "kind": "Literal",
                        "name": "seller",
                        "value": "INCLUDE"
                      }
                    ],
                    "concreteType": "itemSearchMoreLikeThisConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "itemSearchMoreLikeThisEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v26/*: any*/),
                              (v42/*: any*/),
                              (v13/*: any*/),
                              (v43/*: any*/),
                              (v44/*: any*/),
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v52/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quickViewDisplay",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "QuickViewDisplayType",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v39/*: any*/),
                                  (v38/*: any*/)
                                ]
                              },
                              (v54/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "Condition",
                                "passingValue": true,
                                "condition": "showSeller",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "seller",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v55/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "internalBuyLinks",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "anchorText",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "url",
                        "args": null,
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "collectionsModules",
                    "storageKey": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "previewId",
                        "variableName": "contentModuleId"
                      }
                    ],
                    "concreteType": null,
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "CollectionsModulesHero",
                        "selections": [
                          (v22/*: any*/),
                          (v13/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "variation",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CollectionsModulesPhotoCarousel",
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "itemsConnection",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CmsItemsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CmsItemsEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cmsData",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CmsData",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "plural": false,
                                    "selections": [
                                      (v56/*: any*/),
                                      (v42/*: any*/),
                                      (v47/*: any*/),
                                      (v9/*: any*/),
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CollectionsModulesMainContent",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "gridType",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "CollectionsModulesCreatorSpotlight",
                        "selections": [
                          (v13/*: any*/),
                          (v22/*: any*/),
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "itemsConnection",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CmsItemsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CmsItemsEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cmsData",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CmsData",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "plural": false,
                                    "selections": [
                                      (v42/*: any*/),
                                      (v56/*: any*/),
                                      (v44/*: any*/),
                                      (v9/*: any*/),
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "categoryTiles",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseCategoryTiles",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "facets",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFacets",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "location",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FacetValueType",
                            "plural": true,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "label",
                                "args": null,
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v57/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isVerifiedTrade",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "canShowSellerName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favorites",
                    "storageKey": null,
                    "args": [
                      (v4/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "pages",
                        "variableName": "followSearchPages"
                      },
                      {
                        "kind": "Variable",
                        "name": "types",
                        "variableName": "followSearchTypes"
                      }
                    ],
                    "concreteType": "favoritesConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "favoritesEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Favorite",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "recentHistoryList",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "RecentHistoryItem",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "eventDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstPhotoWebPath",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "small"
                              }
                            ],
                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pdpURL",
                            "args": null,
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v32/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "canShowInternalSellerName",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_SELLER_NAME"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "measurementUnit",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "showStrategicPartnerFilter",
                    "name": "hasPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "STRATEGIC_PARTNER_FILTERING"
                      }
                    ],
                    "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                  },
                  (v9/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isTrade",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "expiringPromotion",
                        "storageKey": "expiringPromotion(daysToExpiration:14,promoCodes:[\"TRADEWELCOME\",\"TRADESHIP\",\"RISKFREE\"])",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 14
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADESHIP",
                              "RISKFREE"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          (v58/*: any*/),
                          (v11/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v26/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "rewards",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "educationMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v59/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pointsToMaintainStatus",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pointsMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v59/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "homepageMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v59/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "postCheckoutMessagingSegments",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RewardsMessagingSegment",
                                "plural": true,
                                "selections": (v59/*: any*/)
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "tpnRole",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TradeFirmTPNRole",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isTrade",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "loyalty",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmLoyaltyType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentYearSpend",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "plural": false,
                                    "selections": [
                                      (v34/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "status",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "rewards",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v6/*: any*/),
                                          (v10/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "nextProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v10/*: any*/),
                                          (v9/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirmRewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentPromoSegment",
                            "storageKey": null,
                            "args": (v57/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "segmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "promotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "buyerExpirationDate",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "expiringPromoSegment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "expiringSegmentCode",
                                "args": null,
                                "storageKey": null
                              },
                              (v58/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "sbRespCollectionsRootQuery",
    "id": "app-buyer-finding/235.0.0-2019-10-03T13:32:22.509Z/sbRespCollectionsRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '2c78731c9c72ac416130574d261bfda6';
export default node;
